module.exports = __webpack_public_path__ + "img/leaf-R.001afc89.svg";